import { random } from 'lodash';

export const getRandomInt = () => {
  return random(0, 4294967295); // 2 ** 32 - 1
};

export const generateNewIdInt = (...names: string[]) => {
  return [names ?? [], getRandomInt()].join('.');
};
